export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher100_mob_roi.7e2052a1.png";